import { router } from "@inertiajs/react";
import { Table } from "@mantine/core";
import { StatusIndicator } from "../../../components/indicator/StatusIndicator";
import { UserView } from "../../../components/user/UserView";
import { getFullName } from "../../../helpers/stringHelper";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import type { ApprenticeSupervisor } from "../../../models/apprenticeSupervisor";
import { apprentice_supervisors_path } from "../../../routes";

type ApprenticeSupervisorViewProps = {
  apprenticeSupervisor: ApprenticeSupervisor;
};

export default function ApprenticeSupervisorView({ apprenticeSupervisor }: ApprenticeSupervisorViewProps) {
  const { pathWithYearContext } = useYearContext();
  const onBack = () => router.get(pathWithYearContext(apprentice_supervisors_path));
  return (
    <ContentShell
      title={`Berufsbildner/in ${getFullName(apprenticeSupervisor)}`}
      titleIcon={<StatusIndicator active={apprenticeSupervisor.user.active} />}
      onBack={onBack}
    >
      <Table variant="vertical" layout="fixed" withTableBorder>
        <Table.Tbody>
          <UserView<ApprenticeSupervisor> userType={apprenticeSupervisor} />
          <Table.Tr key="company">
            <Table.Th>Lehrbetrieb</Table.Th>
            <Table.Td>{apprenticeSupervisor.company.name}</Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </ContentShell>
  );
}
